import {useRequest} from "ahooks";

export default (service, options) => {
  if (options.cacheKey && options.cache !== 'session') {
    options.setCache = data => localStorage.setItem(options.cacheKey, JSON.stringify(data));
    options.getCache = () => JSON.parse(localStorage.getItem(options.cacheKey));
  }
  return useRequest(service, options);
}